module.exports = __webpack_public_path__ + "static/media/_transnistria.3636b075.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_transnistria.svg
// module id = 2357
// module chunks = 7